export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6788.c5cc20ea.jpg";